import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { SparkLogo } from './ui/SparkLogo';
interface NavbarProps {
  onNavigate?: (view: any) => void;
  currentView?: any;
}
export function Navbar({
  onNavigate,
  currentView = 'home'
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Insights',
    href: '#insights',
    isRoute: true,
    routeTarget: 'insights'
  }, {
    name: 'Founder',
    href: '#founder',
    isRoute: true,
    routeTarget: 'founder'
  }, {
    name: 'Why SparkHR',
    href: '#why'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-lg border-b border-gray-100 shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-291">
      <div className="max-w-[1240px] mx-auto px-8 flex items-center justify-between" data-id="element-292">
        {/* Logo */}
        <a href="#" onClick={e => {
        if (onNavigate) {
          e.preventDefault();
          onNavigate('home');
        }
      }} className="flex items-center gap-2 group" aria-label="SparkHR Home" data-id="element-293">
          <div className="group-hover:scale-105 transition-transform" data-id="element-294">
            <SparkLogo size={30} data-id="element-295" />
          </div>
          <span className="font-bold text-xl tracking-tight text-gray-900" data-id="element-296">
            Spark<span className="text-gradient" data-id="element-297">HR</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-298">
          {navLinks.map(link => <a key={link.name} href={link.isRoute ? '#' : link.href} onClick={e => {
          if (link.isRoute && onNavigate) {
            e.preventDefault();
            onNavigate(link.routeTarget);
          } else if (!link.isRoute && currentView !== 'home' && onNavigate) {
            e.preventDefault();
            onNavigate('home');
            setTimeout(() => {
              const el = document.querySelector(link.href);
              if (el) el.scrollIntoView({
                behavior: 'smooth'
              });
            }, 100);
          }
        }} className={`text-sm font-medium transition-colors ${link.isRoute && currentView === link.routeTarget ? 'text-purple-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-299">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:block" data-id="element-300">
          <a href="https://calendly.com/krystina-joinsparkhr/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-white bg-gradient-primary rounded-full hover:shadow-md hover:opacity-90 transition-all" data-id="element-301">
            Book an Intro Call
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-gray-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-302">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-303" /> : <MenuIcon className="w-6 h-6" data-id="element-304" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg py-4 px-8 flex flex-col gap-4" data-id="element-305">
          {navLinks.map(link => <a key={link.name} href={link.isRoute ? '#' : link.href} className={`text-base font-medium py-2 border-b border-gray-50 ${link.isRoute && currentView === link.routeTarget ? 'text-purple-600' : 'text-gray-800'}`} onClick={e => {
        if (link.isRoute && onNavigate) {
          e.preventDefault();
          onNavigate(link.routeTarget);
        } else if (!link.isRoute && currentView !== 'home' && onNavigate) {
          e.preventDefault();
          onNavigate('home');
          setTimeout(() => {
            const el = document.querySelector(link.href);
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }, 100);
        }
        setMobileMenuOpen(false);
      }} data-id="element-306">
              {link.name}
            </a>)}
          <a href="https://calendly.com/krystina-joinsparkhr/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-5 py-3 mt-2 text-sm font-medium text-white bg-gradient-primary rounded-full" onClick={() => setMobileMenuOpen(false)} data-id="element-307">
            Book an Intro Call
          </a>
        </div>}
    </header>;
}